import { secondAxios } from "../../../../../api/axios";

export const getProject = async ({ projectId }) => {
  try {
    const res = await secondAxios.get("/project/" + projectId + "/mcs");
    // console.log('res', res);

    return res.data;
  } catch (error) {
    console.log(error);
  }
};
